import { Box } from '@chakra-ui/react';
import { FC } from 'react';

import { Button } from '@bonusly/ds-button';
import { Tooltip } from '@bonusly/ds-tooltip';

import { useDarkMode } from '../hooks/use-dark-mode';

export const DarkModeToggle: FC = () => {
	const { isDarkMode, canToggleDarkMode, toggleDarkMode } = useDarkMode();

	// Only show toggle if user has feature flag
	if (!canToggleDarkMode) {
		return null;
	}

	return (
		<Tooltip label={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'} placement="left">
			<Box>
				<Button
					aria-label={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
					onClick={toggleDarkMode}
					size="sm"
					variant="ghost"
					transition="all 0.2s"
					_hover={{
						transform: 'scale(1.2)',
					}}
				>
					{isDarkMode ? '☀️' : '🌙'}
				</Button>
			</Box>
		</Tooltip>
	);
};
